import './PlayerHp.css';
import HP from "../../hp/HP";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";


function PlayerHp() {

    const {playerHp, battleBg} = useTypedSelector(state => state.game);

    const bgClass = 'playerHP' + battleBg;
    return (
        <div className={'playerHP ' + bgClass} >
            <HP key={'playerhp1'} hp={playerHp} side={'player'}  />
        </div>
    );
}

export default PlayerHp;